import React from 'react'
import { Image, Modal, TypographyStylesProvider } from '@mantine/core'
import { useLotteryData } from '../../hooks'

interface ActivityRulesModalProps {
  opened: boolean
  onClose: () => void
}

const LotteryRulesModal: React.FC<ActivityRulesModalProps> = ({ opened, onClose }) => {
  const { currentLotteryInfo } = useLotteryData()

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      centered
      withCloseButton={false}
      padding={0}
      zIndex={1100}
      overlayProps={{ opacity: 0.9 }}
      styles={{
        body: { padding: 0, background: 'transparent', boxShadow: 'none' },
        content: { background: 'transparent', boxShadow: 'none' },
      }}
    >
      <Image src="/lotteryRules.png" alt="活动规则" />
      <div style={{ background: '#fff' }}>
        <div
          style={{
            padding: '16px 24px 0 24px',
            minHeight: 120,
            maxHeight: 400,
            overflowY: 'auto',
            scrollbarWidth: 'thin',
          }}
        >
          <TypographyStylesProvider>
            {currentLotteryInfo?.rules ? (
              <div
                style={{
                  color: '#3D3D3D',
                  fontSize: '14px',
                  lineHeight: 1.5,
                }}
                dangerouslySetInnerHTML={{ __html: currentLotteryInfo.rules }}
              />
            ) : (
              <div
                style={{
                  textAlign: 'center',
                  color: '#999',
                  fontSize: '14px',
                  padding: '40px 20px',
                  lineHeight: 1.5,
                }}
              >
                <div style={{ fontSize: '32px', marginBottom: '12px' }}>📋</div>
                <div>暂无活动规则信息</div>
              </div>
            )}
          </TypographyStylesProvider>
        </div>
        <Image src={'/iknow.png'} onClick={onClose} />
      </div>
    </Modal>
  )
}

export default LotteryRulesModal
